// extracted by mini-css-extract-plugin
export default {"resetButton":"XH0pKoV","root":"GIcunL3","content":"tZSqbzP","closeButton":"KFefsFW"};